import React from 'react';

export const ExclamationMarkSvg = (props) => {

  const { width, height, warning, color, triangle, plain } = props;

  if (triangle) {
    return (
      <svg width={width ?? "28"} height={height ?? "25"} viewBox="0 0 28 25" fill={color ?? window?.settings?.secondary_color ?? '#04333b'} xmlns="http://www.w3.org/2000/svg">
        <path d="M11.7087 1.43252L0.359136 20.7797C0.125135 21.1935 0.00132075 21.6626 1.05082e-05 22.1404C-0.00129974 22.6183 0.11994 23.0881 0.351668 23.5032C0.583396 23.9184 0.917535 24.2643 1.32084 24.5066C1.72415 24.7489 2.18256 24.8792 2.65048 24.8845H25.3495C25.8174 24.8792 26.2759 24.7489 26.6792 24.5066C27.0825 24.2643 27.4166 23.9184 27.6483 23.5032C27.8801 23.0881 28.0013 22.6183 28 22.1404C27.9987 21.6626 27.8749 21.1935 27.6409 20.7797L16.2913 1.43252C16.0525 1.03039 15.7161 0.697925 15.3148 0.467188C14.9134 0.236451 14.4606 0.115234 14 0.115234C13.5394 0.115234 13.0866 0.236451 12.6852 0.467188C12.2839 0.697925 11.9475 1.03039 11.7087 1.43252Z" />
      </svg>
    )
  }

  if (plain) {
    return (
      <svg width={width ?? "2"} height={height ?? "10"} viewBox="0 0 2 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.00979 9.29167C0.560625 9.29167 0.203125 8.925 0.203125 8.485C0.203125 8.045 0.560625 7.6875 1.00063 7.6875C1.44979 7.6875 1.80729 8.045 1.80729 8.485C1.80729 8.925 1.44979 9.29167 1.00979 9.29167Z" fill={color ?? "#FD2020"} />
        <path d="M0.194336 1.52932C0.194336 1.09024 0.561003 0.722656 1.001 0.722656C1.441 0.722656 1.7985 1.09024 1.7985 1.52932V5.58099C1.7985 6.02191 1.441 6.37849 1.001 6.37849C0.561003 6.37849 0.194336 6.02191 0.194336 5.58099V1.52932Z" fill={color ?? "#FD2020"} />
      </svg>

    )
  }


  return (
    <svg width={width ?? "18"} height={height ?? "18"} viewBox="0 0 18 18" fill={color ? color : warning ? "#E6B300" : "#FD2020"} xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 9C0 4.0329 4.032 0 9 0C13.977 0 18 4.0329 18 9C18 13.9689 13.977 18 9 18C4.032 18 0 13.9689 0 9ZM8.20795 5.58902C8.20795 5.15792 8.56795 4.79702 8.99995 4.79702C9.43195 4.79702 9.78295 5.15792 9.78295 5.58902V9.56702C9.78295 9.99992 9.43195 10.35 8.99995 10.35C8.56795 10.35 8.20795 9.99992 8.20795 9.56702V5.58902ZM9.00874 13.2128C8.56774 13.2128 8.21674 12.8528 8.21674 12.4208C8.21674 11.9888 8.56774 11.6378 8.99974 11.6378C9.44074 11.6378 9.79174 11.9888 9.79174 12.4208C9.79174 12.8528 9.44074 13.2128 9.00874 13.2128Z" />
    </svg>
  )
}